import React from 'react';
import { useTranslation } from 'react-i18next';
import ChooseMediaModal from '@/components/media/ChooseMediaModal';

export interface ChangePhotoModalProps {
  familyId: string;
  familyMemberId: string;
  isOpen: boolean;
  onClose: () => void;
  onSelect: (mediaAssetId: string) => void;
  onUploadSuccess?: () => void;
}

const ChangePhotoModal: React.FC<ChangePhotoModalProps> = (props) => {
  const { t } = useTranslation('forms');
  return (
    <ChooseMediaModal
      title={t('person.changePhoto')}
      familyId={props.familyId}
      familyMemberId={props.familyMemberId}
      isOpen={props.isOpen}
      onClose={props.onClose}
      onSelect={props.onSelect}
      onUploadSuccess={props.onUploadSuccess}
    />
  );
};

export default ChangePhotoModal;
